import { useMemo } from 'react';
import { useLocation } from 'react-router-dom';

export interface CrossTabNavigationOptions {
  targetTab: string;
  sourceTab: string;
  additionalParams?: Record<string, string>;
}

export const useCrossTabNavigation = () => {
  const location = useLocation();

  const generateCrossTabUrl = useMemo(
    () =>
      ({ targetTab, sourceTab, additionalParams = {} }: CrossTabNavigationOptions) => {
        const searchParams = new URLSearchParams(location.search);

        // Add cross-tab navigation parameters
        searchParams.set('from', sourceTab);
        searchParams.set('fromUrl', encodeURIComponent(location.pathname + location.search));

        // Add any additional parameters (like memberIds, filters, etc.)
        Object.entries(additionalParams).forEach(([key, value]) => {
          searchParams.set(key, value);
        });

        return {
          pathname: `/social/analytics/${targetTab}`,
          search: searchParams.toString(),
        };
      },
    [location],
  );

  return {
    generateCrossTabUrl,
  };
};

export default useCrossTabNavigation;
